/**
 * 補足説明のボックス
 * @param {string} description - 説明文
 */

import React from "react";

interface DescriptionBoxProps {
	description: React.ReactNode;
	image?: string;
	alt?: string;
}

export const DescriptionBox: React.FC<DescriptionBoxProps> = ({
	description,
	image,
	alt
}) =>(
	<>
		<br />
		<br />
		<div style={{ 
			border: "1px solid #ccc", 
			padding: "16px", 
			borderRadius: "8px", 
			backgroundColor: "#f9f9f9"}}>
		<p className="c-text">
			{description}
		</p>
		{image && (
    	<>
        	<br />
        	<img src={image} alt={alt} className="step-image"/>
    	</>
    )}
		</div>
	</>
);